export default __webpack_public_path__ + "static/media/tag.0319c981.png";